export default (value: number) => {
    switch (true) {
        case value < 120: return 'Under 2 hours';
        case value < 241: return '4 hours';
        case value < 361: return '6 hours';
        case value < 481: return '8 hours';
        case value < 601: return '10 hours';
        default:
            var durationInDays = ((value / 60) / 8);
            var durationDecimals = durationInDays - Math.floor(durationInDays);
            if (durationDecimals >= 0.01 && durationDecimals <= 0.5) {
                return `${Math.floor(durationInDays) + 0.5} days`;
            } else {
                return `${Math.ceil(durationInDays)} days`;
            }
    }
};